// カテゴリ詳細ページ: 説明文の「もっと見る/閉じる」開閉(SPのみ・アニメーション付き)
//
// 3行クランプはSPのメディアクエリでのみ有効なため、トグルの要否は
// ロード時に一度だけ判定せず、リサイズのたびに再評価する
// (PC幅でロード→SP幅に変わるケースでボタンが出なくなるのを防ぐ)
window.addEventListener('DOMContentLoaded', () => {
  const wraps = document.querySelectorAll('.konintodoke-category-detail__description-wrap')
  wraps.forEach((wrap) => {
    const desc = wrap.querySelector('.konintodoke-category-detail__description')
    const toggle = wrap.querySelector('.konintodoke-category-detail__toggle')
    if (!desc) return

    const isExpanded = () => desc.classList.contains('-expanded')

    // クランプが効いていて溢れている時だけトグルと白フェードを表示する。
    // inline styleではなくクラスで制御し、メディアクエリと衝突しないようにする。
    // ボタンは「すべて」のようにサーバー側で描画されない場合がある(フェード判定のみ行う)
    const updateToggleVisibility = () => {
      const overflowing = desc.scrollHeight > desc.clientHeight + 1
      if (toggle) toggle.classList.toggle('-unneeded', !overflowing && !isExpanded())
      // 溢れていない説明文には白フェードもかけない(ボタンと同じ条件に連動)。
      // 展開中はフェード制御を-expanded側に任せるため触らない
      if (!isExpanded()) desc.classList.toggle('-fits', !overflowing)
    }
    updateToggleVisibility()
    window.addEventListener('resize', updateToggleVisibility)
    if (!toggle) return

    const setAria = (expanded) => {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false')
      toggle.setAttribute('aria-label', expanded ? '説明文を閉じる' : '説明文の続きを表示')
    }

    // 展開アニメーション終了時に max-height を開放するリスナー。
    // 途中で中断(transitioncancel)された場合も必ず解除し、
    // 古いリスナーが後続の閉じアニメーション終了時に発火して
    // 「閉じたのに全開へスナップする」事故を防ぐ
    let releaseOnEnd = null
    const clearReleaseListener = () => {
      if (!releaseOnEnd) return
      desc.removeEventListener('transitionend', releaseOnEnd)
      desc.removeEventListener('transitioncancel', releaseOnEnd)
      releaseOnEnd = null
    }

    toggle.addEventListener('click', () => {
      if (!isExpanded()) {
        // 展開: 実高さ(px)へトランジション → 終わったら none にして自由化
        desc.classList.add('-expanded')
        toggle.classList.add('-expanded')
        setAria(true)
        desc.style.maxHeight = `${desc.scrollHeight}px`
        releaseOnEnd = (e) => {
          if (e.propertyName !== 'max-height') return
          if (e.type === 'transitionend' && isExpanded()) {
            desc.style.maxHeight = 'none'
          }
          clearReleaseListener()
        }
        desc.addEventListener('transitionend', releaseOnEnd)
        desc.addEventListener('transitioncancel', releaseOnEnd)
      } else {
        // 折りたたみ: 現在の実高さを起点として確定させてから3行へトランジション
        clearReleaseListener()
        desc.style.maxHeight = `${desc.scrollHeight}px`
        // 強制リフローで上の px 値をスタイルとして確定させる
        // (これがないと同一フレーム内で上書きされ、アニメーションせず一瞬で閉じる)
        void desc.offsetHeight
        desc.classList.remove('-expanded')
        toggle.classList.remove('-expanded')
        setAria(false)
        desc.style.maxHeight = ''
      }
    })
  })
})
